import React, { Component } from 'react'
import Education from '../components/Education/Education'
import Experience from '../components/Experience/Experience'
import Skill from '../components/Skill/Skill'
import Volunteer from '../components/Volunteer/Volunteer';
export default class Resume extends Component {
    componentDidMount() {
        var goHere = function () {

            window.$('.mouse-icon').on('click', function (event) {

                event.preventDefault();

                window.$('html,body').animate({
                    scrollTop: window.$('.goto-here').offset().top
                }, 500, 'easeInOutExpo');

                return false;
            });
        };
        goHere();


        //variable that will hold the href attr of the links in the menu
        var sections = [];
        //variable that stores the id of the section
        var id = false;
        //variable for the selection of the anchors in the navbar
        var $navbara = window.$('#navi a');

        $navbara.click(function (e) {
            //prevent the page from refreshing
            e.preventDefault();
            //set the top offset animation and speed
            window.$('html, body').animate({
                scrollTop: window.$(window.$(this).attr('href')).offset().top - 180
            }, 500);
            window.hash(window.$(this).attr('href'));
        });

        //select all the anchors in the navbar one after another
        $navbara.each(function () {
            // and adds them in the sections variable
            sections.push(window.$(window.$(this).attr('href')));

        })
        window.$(window).scroll(function (e) {
            // scrollTop retains the value of the scroll top with the reference at the middle of the page
            var scrollTop = window.$(this).scrollTop() + (window.$(window).height() / 2);
            //cycle through the values in sections array
            for (var i in sections) {
                var section = sections[i];

                //if scrollTop variable is bigger than the top offset of a section in the sections array then 
                if (sections[i].length) {
                    if (scrollTop > section.offset().top) {
                        var scrolled_id = section.attr('id');
                    }
                }
            }
            if (scrolled_id !== id) {
                id = scrolled_id;
                window.$($navbara).removeClass('current');
                window.$('#navi a[href="#' + id + '"]').addClass('current');
            }
        })
        window.hash = function (h) {
            if (window.history.pushState) {
                window.history.pushState(null, null, h);
            } else {
                window.location.hash = h;
            }
        }
    }
    render() {
        return (
            <>
                <section className="ftco-section ftco-no-pb goto-here" id="resume-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <nav id="navi">
                                    <ul>
                                        <li><a href="#page-1">Education</a></li>
                                        <li><a href="#page-2">Experience</a></li>
                                        {/* <li><a href="#page-3">Skills</a></li> */}
                                        <li><a href="#page-3">Volunteer</a></li>
                                    </ul>
                                </nav>
                            </div> {/* Side Nav End */}
                            <div className="col-md-9">
                                <div id="page-1" className="page one">
                                    <Education />
                                </div>
                                <div id="page-2" className="page two">
                                    <Experience />
                                </div>
                                {/* <div id="page-3" className="page three">
                                    <Skill />
                                </div> */}
                                <div id="page-3" className="page three">
                                    <Volunteer />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}
